import React from 'react'
import './create-timesheet-are-you-sure.css'

const CreateTimesheetAreYouSure = (props) => {
    return(
        <div className="create-timesheet-are-you-sure-wrapper">
            <div className="create-timesheet-are-you-sure">
                <h2>Are you sure?</h2>
                <p>Remember that any date listed on your timesheet will be billed to the family.</p>
                <p>Make sure all dates are accurate and all names are spelled correctly.</p>
                <div className="create-timesheet-are-you-sure_btn-area">
                    <div className="create-timesheet-bottom-btns go-yellow" onClick={() => props.setFinalWarning(false)}>Go back</div>
                    <div className="create-timesheet-bottom-btns go-green" onClick={() => props.submitTimesheet()}>Yes, Submit</div>
                </div>
            </div>
        </div>
    )
}
export default CreateTimesheetAreYouSure